

<span style="filter: invert(66%) sepia(16%) saturate(5379%) hue-rotate(326deg) brightness(93%) contrast(90%);" >
    <slot />
</span>